import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	done: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inProgress: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	toDo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	empty: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	done: {
		id: 'project-versions.table.progress-bar.done',
		defaultMessage: '{done} done',
		description: 'Message for on hover tooltip for done issues in progress bar',
	},
	inProgress: {
		id: 'project-versions.table.progress-bar.in-progress',
		defaultMessage: '{inProgress} in progress',
		description: 'Message for on hover tooltip for in progress issues in progress bar',
	},
	toDo: {
		id: 'project-versions.table.progress-bar.to-do',
		defaultMessage: '{toDo} to do',
		description: 'Message for on hover tooltip for to do issues in progress bar',
	},
	empty: {
		id: 'project-versions.table.progress-bar.empty',
		defaultMessage: 'No issues',
		description:
			'What is displayed when there are no issues in progress bar instead of progress bar',
	},
	emptyIssueTermRefresh: {
		id: 'project-versions.table.progress-bar.empty-issue-term-refresh',
		defaultMessage: 'No work items',
		description:
			'What is displayed when there are no issues in progress bar instead of progress bar',
	},
});
export default messages;
